import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { useInvalidateReservationGroupQuery } from '@mews-commander/core/entities';
import { selectionIsUnCheckOutable as selectionIsUnCheckOutableSelector } from '../../selectors/reservationModuleState/reservationSelection';
import { UndoCheckOutForm } from '../undoCheckInCheckOutFactory';
import { formCardFactory } from '../formCardFactory';
import { getCheckedReservationIds } from '../../selectors';
import { fetchCurrentEnterpriseCheckedReservations } from '../../actions';
import { RESERVATION_BARE_MINIMUM_EXTENT } from '../../constants';

const UndoCheckOutFormCardElement = formCardFactory({
    FormElement: UndoCheckOutForm,
    titleTextKey: TextKey.UndoCheckOut,
    onSuccessMessageKey: TextKey.ReservationUndoCheckOutSuccessMessage,
    dataTestId: 'undo-checkout-form',
});
const UndoCheckOutFormCard = ({ selectionIsUnCheckOutable, ...other }: $TSFixMe) => {
    const { scope } = other;
    const isReservationModuleReactQueryEnabled = useFeatureFlag(FeatureFlag.reservationModuleReactQueryEnabled);
    const dispatch = useCommanderThunkDispatch();
    const invalidateReservationData = useInvalidateReservationGroupQuery(other.scope);
    const invalidateReservationDataRedux = () =>
        dispatch(fetchCurrentEnterpriseCheckedReservations({ scope, extent: RESERVATION_BARE_MINIMUM_EXTENT }));
    const refetchGroup = isReservationModuleReactQueryEnabled
        ? invalidateReservationData
        : invalidateReservationDataRedux;
    if (!selectionIsUnCheckOutable) {
        return null;
    }
    return <UndoCheckOutFormCardElement {...other} refetchGroup={refetchGroup} />;
};

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        selectionIsUnCheckOutable: selectionIsUnCheckOutableSelector,
        reservationIds: getCheckedReservationIds,
    })
)(UndoCheckOutFormCard);
